<script setup lang="ts">
import { useApiFetch } from "~/composible/useApiFetch";

const router = useRouter();
const route = useRoute();

const currentPage = ref(route.query.page ? Math.abs(parseInt(route.query.page as string)) : 1);
const term = ref(route.query.q ? route.query.q as string : '');
const dd = ref(term.value);

const { data: tags, error:tagError } = useApiFetch('/tags/top', {
  transform: (tags) => tags.data,
  lazy: true
});

const { data, error, status } = useApiFetch('/search', {
  query: { page: currentPage, term: dd },
  watch: [currentPage, dd]
});

const clearSearch = () => {
  currentPage.value = 1;
  term.value = '';
  doSearch();
}

let searchTimer;
const doSearch = () => {
  clearTimeout(searchTimer);
  searchTimer = setTimeout(() => {
    currentPage.value = 1;
    dd.value = term.value;
    router.push({ query: { q: term.value, page: currentPage.value } });
  }, 700)
}

const onChangePage = (page: number) => {
  router.push({ query: { q: term.value, page: page } });
  if (process.browser){
    nextTick(() => window.scrollTo({ top: 0 }))
  }
};

useSeoMeta({
  title: 'Search Novels - FictionMe',
  titleTemplate: '%s'
});
</script>

<template>
  <div class="container py-8 max-md:py-6">
    <div class="page-content flex-col gap-8">
      <lazy-f-card>
        <div class="search-field relative">
          <input v-model="term" @keyup="doSearch" placeholder="Search Novel title or Tag" class="py-2 px-14 w-full outline-0 bg-gray-50 rounded-lg border border-gray-100 dark:bg-zinc-950 dark:border-zinc-700" />
          <icon name="fm:search" class="absolute left-4 top-2 text-2xl text-gray-400" />
          <button @click.prevent="clearSearch" :disabled="!term || term.length === 0" class="absolute flex w-[50px] h-full items-center justify-center right-0 top-0 text-sm text-primary disabled:text-gray-100 dark:disabled:text-gray-700">
            <icon name="fm:cross"  />
          </button>
        </div>

        <template v-if="tags && tags.length > 0">
          <h2 class="text-2xl font-semibold mb-5 mt-8">Top Tags</h2>

          <div  class="flex flex-wrap gap-4 max-md:gap-2">
            <nuxt-link v-for="tag in tags" :to="`/stories/${tag.slug}-novels`">
              <tag>{{ tag.name }}</tag>
            </nuxt-link>
          </div>
        </template>
      </lazy-f-card>

      <div v-loading="['pending', 'idle'].includes(status)">
        <lazy-f-card v-if="status === 'success'">
          <div class="flex flex-col gap-10 mb-8">
            <div class="grid gap-7 grid-cols-2 max-md:grid-cols-1">
              <book-detailed-card
                  v-for="book in data.data"
                  :book="book"
                  :key="book.id"
              />
            </div>

            <pagination
                v-if="data?.meta && data.meta.last_page > 1"
                v-model="currentPage"
                :total-pages="data.meta.last_page"
                @changed="onChangePage"
            />
          </div>
        </lazy-f-card>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>